
<template>
  <div>
    <v-card text style="border: 0px">
      <v-card-title primary-title>
        <v-row class="px-3" align="center">
          <div class="headline mb-0">Histórico financeiro do motorista</div>
          <v-spacer></v-spacer>
          <print-transactions-history :type_tabs="type_tabs"></print-transactions-history>
        </v-row>
      </v-card-title>
      <v-card-text style="overflow-y: auto; height: 70vh">
        <v-row justify="space-around" class="d-flex" v-if="!loading_driver">
          <v-col cols='11' sm='5' md='4'>
            <v-card class="elevation-1 py-2" style="border-radius:12px">
              <v-card-text class="pa-2 px-4">
                <v-row justify="space-around">
                  <div class="title">Total em fretes</div>
                  <div class="title">{{Number(shippings_total_sum).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols='11' sm='5' md='4'>
            <v-card class="elevation-1 py-2" style="border-radius:12px">
              <v-card-text class="pa-2 px-4">
                <v-row justify="space-around">
                  <div class="title">Total em pagamentos</div>
                  <div class="title">{{Number(payments_total_sum).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify='center'>
          <v-col cols='12' md='12' lg='12'>
            <v-timeline dense clipped v-if="historic.length">
              <template v-for="(hf, idx) in historic_comp">
                <v-timeline-item class="mb-3" :color="financial_data[hf.type].dot_color"
                  :icon="financial_data[hf.type].dot_icon" :key="'hftl' + idx"
                >
                  <v-row justify="space-between">
                    <v-col cols='9' class='text-left'>
                      <v-tooltip top color="black">
                        <template v-slot:activator="{ on }">
                          <v-chip v-on="on" pill @click="openOrderInNewTab(hf.order_id)">
                            <v-avatar left :class="financial_data[hf.type].chip[hf.kind].avatar_color">
                              <v-icon small color="white">{{ financial_data[hf.type].chip[hf.kind].icon }}</v-icon>
                            </v-avatar>
                            R$ {{ Number(hf.ammount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}
                          </v-chip>
                        </template>
                        {{ hf.order_id ? 'Ver pedido' : hf.text }}
                      </v-tooltip>
                      {{ hf.text }} {{ hf.comment && !hf.order_id ? hf.comment : '' }} 
                      <v-btn v-if="hf.type == 'payment' && hf.payeds.length > 0" small color="primary" icon @click="openPaymentInfos(hf)"><v-icon>mdi-information</v-icon></v-btn>
                      <v-spacer></v-spacer>
                      <template v-if="hf.type == 'payment'">
                        <FileAttachment class="ma-2" :attached_file_url="hf.attached_file_url" ref="attach" :update_infos="{API: 'InternalPayment',MODEL:'internal_payment', id: hf.id}"></FileAttachment>
                      </template>
                    </v-col>
                    <v-col cols='3' text-xs-right>
                      {{ new Date(hf.payed_at).toLocaleDateString('pt-BR') }}
                      <div v-if="hf.creator_name" class="grey--text font-weight-bold"> por: {{ hf.creator_name }}</div>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-1"></v-divider>
                </v-timeline-item>
              </template>
            </v-timeline>
          </v-col>

        </v-row>
        <v-alert type="warning" :value="true" v-if="!historic.length && !loading_driver">
          Não possui histórico nesse período.
        </v-alert>
        <v-alert type="info" :value="true" v-if="loading_driver">
          Carregando Histórico
          <v-progress-linear color="white" :indeterminate="true"></v-progress-linear>
        </v-alert>

        <v-btn color="primary" @click="loadMoreData()"> carregar <v-icon right small>mdi-plus</v-icon> </v-btn>

      </v-card-text>

    </v-card>


    <v-dialog v-model="releated_shippings_dialog" v-if="releated_shippings_dialog" max-width="800px">
      <v-card>
        <v-card-title>
          Fretes relacionados
        </v-card-title>

        <v-card-text class="py-0" :style="releated_shippings.length > 3 ? 'overflow-y: auto; height:60vh' : ''">
          <v-divider></v-divider>
          <div v-for="(item, idx) in releated_shippings" :key="idx">
            <v-divider v-if="idx"></v-divider>
            <v-list dense >
              <v-subheader><h3>Entrega {{idx + 1}} - Pedido: #{{ item.order_id }}</h3></v-subheader>
              <v-list-item-group  v-if="item">
                <v-list-item>
                  <v-list-item-content>Valor total do frete <v-list-item-title> R$ {{item.total_shipping_value}} </v-list-item-title></v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Valor pago <v-list-item-title> R$ {{item.ammount_payed}} </v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>

          <h3 class="d-flex justify-center pb-6 pt-5" v-if="releated_shippings.length == 0 && !loading_selected_item">Sem histórico</h3>
          <card-loading-transparent v-if="loading_selected_item && releated_shippings.length == 0"></card-loading-transparent>

          <v-divider></v-divider>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small class="error" @click="closePaymentInfos">fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import { mapState } from 'vuex'
import Api from '@/api/index';
import PrintTransactionsHistory from "./PrintHistoryTransactions.vue"

export default {
  name: 'DriverFinancialHistoric',
  components: {
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
    PrintTransactionsHistory,
  },
  props:{
    type_tabs:{
      type: Number,
      default: 0,
    },
    selectedSolution: {
      type: String,
      default: null
    },
    modality_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      releated_shippings: [],
      loading_selected_item: false,
      releated_shippings_dialog: false,

      loading_driver: false,
      shippings_total_sum: 0,
      payments_total_sum: 0,

      historic: [],

      start_date: this.$moment().subtract(2, 'month').format('YYYY-MM-DD'),
      end_date: this.$moment().add(1, 'day').format('YYYY-MM-DD'),

      order_id: null,

      financial_data: {
        payment: {
          dot_icon: 'mdi-swap-horizontal',
          dot_color: 'success',
          chip: {
            payment: {
              icon: 'mdi-email',
              text: 'Envelope',
              avatar_color: 'green darken-2',
            },
            box: {
              icon: 'mdi-cash-fast',
              text: 'Depósito',
              avatar_color: 'green darken-3',
            }
          },
        },
        vrt_transaction: {
          dot_icon: 'mdi-swap-horizontal',
          dot_color: 'error',
          chip: {
            vrt_transaction: {
              icon: 'mdi-barcode',
              text: 'Boleto',
              avatar_color: 'red darken-3',
            },
          },
        },
        invoice: {
          dot_icon: 'mdi-swap-horizontal',
          dot_color: 'primary',
          chip: {
            shipping: {
              icon: 'mdi-truck',
              text: 'Entrega',
              avatar_color: 'primary darken-1',
            },
          },
        },

      },
      URL_MAP: {
        'wholesale' : { 
          label: 'Grandes cargas',
          icon: 'mdi-store-settings',
          color: '#E53935',
          kind: 'wholesale',
          link: '',
          development_link: 'http://localhost:3000/order',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
        'retail' :{ 
          label: 'Galpão',
          icon: 'mdi-cart',
          color: '#E53935',
          kind: 'retail',
          link: '',
          development_link: 'http://localhost:8080/order',
          function: (path) => { window.open(path, '_blank'); this.dialog = false }
        },
      }
    }
  },
  computed: {
    model_type_tabs(){
      return "Driver"
    },
    historic_comp() {
      if (this.historic.length) {
        return this.historic
      }
      return []
    },
    ...mapState({
      activeDepotId: state => state.App.activeDepotId,
      oneDriver: state => state.Driver.oneDriver,
    })
  },
  methods: {
    closePaymentInfos(){
      this.releated_shippings_dialog = false
      this.releated_shippings = []
    },
    openPaymentInfos(item){
      this.releated_shippings_dialog = true
      this.loading_selected_item = true
      this.releated_shippings = []
      let item_ids = item.payeds.map(el => el.payable_id) 

      Api.Shipping.index({ ids: item_ids }).then(r=>{
        this.releated_shippings = r.data
      }).catch(err=>{
        console.log(err)
      }).finally(() => {
        this.loading_selected_item = false
      })
    },
    openOrderInNewTab(order_id){
      this.URL_MAP[this.selectedSolution].function(`${this.URL_MAP[this.selectedSolution].link}/${order_id}`)
    },
    setLinks(){
      let wholesale = {
        production_link: 'https://grandes_cargas.webcimentao.com.br/concluded/order',
        development_link: 'http://localhost:3000/concluded/order',
        qa_link: 'https://grandes_cargas_qa2.webcimentao.com.br/concluded/order',
      }
      let retail = {
        production_link: 'https://galpoes.webcimentao.com.br/order',
        development_link: 'http://localhost:8080/order',
        qa_link: 'https://galpoes-qa.webcimentao.com.br/order',
      }

      let origin = window.location.origin
      let link_check = origin.split('//')[1].split('.')[0].split(':')[0]

      if(link_check == 'gestao-qa' || link_check == 'varejo-m' || link_check == 'grandes_cargas_m'){
        this.URL_MAP['wholesale'].link = wholesale.qa_link
        this.URL_MAP['retail'].link = retail.qa_link
      }else if(link_check == 'webcimentao' || link_check == 'varejo' || link_check == 'gestao'){
        this.URL_MAP['wholesale'].link = wholesale.production_link
        this.URL_MAP['retail'].link = retail.production_link
      }else if(link_check == 'localhost'){
        this.URL_MAP['wholesale'].link = wholesale.development_link
        this.URL_MAP['retail'].link = retail.development_link
      }
    },
    loadMoreData() {
      this.start_date = this.$moment(this.start_date).subtract(2, 'month').format('YYYY-MM-DD')
      this.getDriverHistoric()
    },
    handleCloseDialog() {
      this.order_id = null
    },
    getFilter(){
      let is_driver = this.model_type_tabs == "Driver"
      return {
        destinable_type: 'Driver',
        destinable_id: this.oneDriver.data.id,
        driver_id: this.oneDriver.data.id,
        is_historic: true,
        start_date: this.start_date,
        end_date: this.end_date,
        modality_id: this.modality_id,
        status_ids: [20] //{"in_progress"=>1, "delivered"=>10, "payed"=>20, "overdue"=>30}
      }
    },
    getDriverHistoric() {
      this.loading_driver = true
      let filter = this.getFilter()
      Api.InternalPayment.index(filter).then(r => r.data).then(res => {
        let {data, payments_total_sum, shippings_total_sum} = res
        this.payments_total_sum = payments_total_sum
        this.shippings_total_sum = shippings_total_sum
        this.historic = [...data]
      }).catch(err => {
        console.error(err);
      }).finally(() => {
        setTimeout(() => {
          this.loading_driver = false
        }, 500);
      })
    },
  },
  mounted() {
    this.getDriverHistoric()
    this.setLinks()
  },

}
</script>
